import { Loader } from '../../styles/Loader'
import { ButtonType } from '../../types/components'
import { ButtonWrapper } from './styles'

const Button = ({
	children,
	onBtnClick,
	isEnabled,
	isLoading,
	height,
	width,
}: ButtonType) => {
	return (
		<>
			{isLoading && (
				<ButtonWrapper type="button" disabled={true}>
					<Loader />
				</ButtonWrapper>
			)}
			{!isLoading && (
				<ButtonWrapper
					type="button"
					onClick={onBtnClick}
					disabled={!isEnabled}
					height={height}
					width={width}
				>
					{children}
				</ButtonWrapper>
			)}
		</>
	)
}

export default Button
